/**
 * LOS DIAS DE ASISTENCIA DE UN COLABORADOR, SACADOS DEL DETECTOR (SUJ-T2, ASSIGN #17005).
 *
 * QUE PASO. La ficha del colaborador filtraba las filas del detector por colaboradorId o
 * colaboradorNombre, y AnomaliaAsistenciaDto no trae ninguno de los dos: trae el nombre en
 * `colaborador` y ningun id. Medido el 21-sep en la base: los 4 nombres del detector en Exito
 * Chino (30 dias) igualan exacto a colaboradores.nombre_completo; Brayan Ortiz Bayona, 25 dias.
 * Con el filtro viejo, la ficha habria dicho "Sin marcajes" para todos el dia que el API deje
 * de dar 500 (FINDING #17026).
 *
 * El cruce es por nombre normalizado porque es lo unico que el detector entrega; si un dia el
 * DTO trae el id, el id manda. Se lee de las formas que ya vimos (camelCase, snake_case).
 *
 * Sin DOM: lo prueba scripts/check-ficha-asistencia.mjs.
 */

const norm = (s) => String(s ?? '').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ');

/** Las filas del detector dentro de la respuesta de ApiBase ({ok, data: {data: {items}}}). */
export function filasDelDetector(res) {
  if (!res || !res.ok) return [];
  const cuerpo = res.data || {};
  const dentro = cuerpo.data || cuerpo;
  return Array.isArray(dentro.items) ? dentro.items : Array.isArray(dentro.Items) ? dentro.Items : [];
}

/** Las filas que son de ESTE colaborador: por id si el detector lo trae, si no por nombre. */
export function filasDelColaborador(filas, colaborador) {
  if (!Array.isArray(filas) || !colaborador) return [];
  const id = String(colaborador.id ?? colaborador.colaboradorId ?? '').trim();
  const nombre = norm(colaborador.nombreCompleto ?? colaborador.nombre_completo ?? colaborador.nombre);
  return filas.filter((f) => {
    const suId = String(f.colaboradorId ?? f.colaborador_id ?? '').trim();
    if (suId && id) return suId === id;
    const suNombre = norm(f.colaborador ?? f.colaboradorNombre ?? f.colaborador_nombre);
    return nombre !== '' && suNombre === nombre;
  });
}

/** Conteo por clasificacion, de mayor a menor: [[clasificacion, n], ...]. */
export function conteoPorClase(filas) {
  const porClase = {};
  for (const f of filas || []) {
    const c = String(f.clasificacion || 'sin_clasificar').toLowerCase();
    porClase[c] = (porClase[c] || 0) + 1;
  }
  return Object.entries(porClase).sort((a, b) => b[1] - a[1]);
}
